export default __webpack_public_path__ + "static/DW-Apple-c09270f2260a14c2ee70b75a3932f8db.svg";